import { useQuery } from 'react-query'

import { fetchRecurringInvoice } from '@features/recurringInvoices/query-api'

import { QueryKeys } from '../../../../../enums/queryKeys'

export const useFetchRecurringInvoice = (recurringInvoiceId: string) => {
  const {
    data: recurringInvoiceData,
    isLoading,
    ...rest
  } = useQuery([QueryKeys.RecurringInvoice, recurringInvoiceId], () => fetchRecurringInvoice(recurringInvoiceId), {
    enabled: !!recurringInvoiceId,
  })

  return { recurringInvoice: recurringInvoiceData?.data, isLoading, ...rest }
}
